import React, { useContext, createContext, useState, useEffect } from "react";
import { auth } from "../firebaseConfig";
import {
  signInWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {


  const [currentUser, setCurrentUser] = useState();
  const [error,setError]= useState('');

  async function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password)
      .then((userCredentials) => {
        const user = userCredentials.user;
        setCurrentUser(user);
        setError('');
      })
      .catch((error) => {
        setError(error)
      });
  }

  async function logout() {
    signOut(auth);
    setCurrentUser(null);
  }

  const value = {
    currentUser,
    logIn,
    logout,
    error,
    setError
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
